export enum CustomAudienceLookbackWindowEnum {
  WEEK_1 = 1,
  WEEK_2 = 2,
  WEEK_3 = 3,
  WEEK_4 = 4,
  MONTH_1 = 1,
  MONTH_2 = 2,
  MONTH_3 = 3,
  DAYS_7 = 7,
  DAYS_14 = 14,
  DAYS_30 = 30,
  DAYS_60 = 60,
  DAYS_90 = 90,
}



